import { Grid } from '@mui/material'
import { SimpleForm,  BooleanInput, TextInput, required } from 'react-admin'
// import dayjs from 'dayjs'
import { COMMON_FIELDS , CATALOGUES_FIELDS} from '../../providers/localization/constant'
import { CreateBase } from '../../components/base'
// import { isAfterDate, isBeforeDate } from '../../utils/validators'
// import { ImageInput } from '../../components/inputs'
import { SigleFileInput } from '../../components/inputs/SigleFileInput'
import {
//   ActionSelectInput,
FormBottomToolbarWithPermission,
//   PublicNewsSelectInput,
//   TargetLinkSelectInput,
//   TextInputTargetValue,
} from '../../components/form'

const CatalogueCreate = (): JSX.Element => {
    // const translate = useTranslate()
//   const defaultDate = dayjs()
//   const defaultExpireDate = defaultDate.add(1, 'month')
//   const postDefaultValue = (): object => ({ publish_condition: 'a' })
  return (
    <CreateBase
      title={`${CATALOGUES_FIELDS}.create.title`}
      listAction={{
        hasBackButton: true,
      }}
      encType='multipart/form-data'
    >
      <SimpleForm
        toolbar={
            <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} isCreate={true} />
          }
        // defaultValues={postDefaultValue}
      >
        <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextInput
            source='title_th'
            label={`${CATALOGUES_FIELDS}.title_th`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='title_en'
            label={`${CATALOGUES_FIELDS}.title_en`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='description_th'
            label={`${CATALOGUES_FIELDS}.description_th`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='description_en'
            label={`${CATALOGUES_FIELDS}.description_en`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='period_th'
            label={`${CATALOGUES_FIELDS}.period_th`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='period_en'
            label={`${CATALOGUES_FIELDS}.period_en`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>

        <Grid item xs={12}>
          <SigleFileInput
            source='file'
            // isApproved={preventEdit}
            label={`${CATALOGUES_FIELDS}.edit.file`}
            helperText={`${CATALOGUES_FIELDS}.edit.attachment_helper`}
            fallbackSource='full_path'
            accept='application/pdf'
          />
        </Grid>
      </Grid>
      </SimpleForm>
    </CreateBase>
  )
}

export default CatalogueCreate